//@flow

import React, { useContext, useEffect } from "react";
import { Field, useField } from "react-final-form";
import type { FieldRenderProps } from "react-final-form";
import { changeServiceFormInteraction } from "Commons/Utilities/GoogleTagManager";
import { Error, Dropdown, Column, ColumnContainer } from "modules/ChangeServiceForm/components/shared/CommonComponents";
import { required, composeValidators, isDate } from "modules/ChangeServiceForm/misc/validations";
import * as Options from "Commons/Components/FormComponents/components/DateSelect/Options";
import ChangeServiceFormSharedContext from "modules/ChangeServiceForm/misc/context";

const BirthDate = ({ stepName }: { stepName: string }) => {
  const {
    inheritedStyles: {
      formColumn,
      formColumnContainer,
      columnContainerMobileDivided,
      columnContainerDesktopDivided,
      columnMobileW1,
      columnDesktopW1,
      columnMobileW2,
      columnDesktopW2,
      errorMessage,
    },
  } = useContext(ChangeServiceFormSharedContext);

  const birthDate = useField("dateOfBirth");
  const birthDay = useField("birthDay");
  const birthMonth = useField("birthMonth");
  const birthYear = useField("birthYear");

  useEffect(() => {
    if (birthDay.input.value && birthMonth.input.value && birthYear.input.value) {
      birthDate.input.onChange(formatBirthDate(birthDay.input.value, birthMonth.input.value, birthYear.input.value));
    }
  }, [birthDay, birthMonth, birthYear]);

  const startYear = new Date().getFullYear() - 117;
  const yearOptions = Options.getYears({ startYear, numYears: 100 });
  const monthOptions = Options.monthNames;
  const dayOptions = Options.days;

  const formatBirthDate = (day, month, year) => {
    return `${year}-${("0" + month).slice(-2)}-${("0" + day).slice(-2)}`;
  };

  return (
    <>
      <Field name={"dateOfBirth"} validate={composeValidators(required, isDate)}>
        {({ input: { onChange, value }, meta }: FieldRenderProps) => {
          return (
            <ColumnContainer
              className={formColumnContainer}
              mobile={columnContainerMobileDivided}
              desktop={columnContainerDesktopDivided}
            >
              <Column className={formColumn} mobile={columnMobileW2} desktop={columnDesktopW2}>
                <Field name={"birthDay"}>
                  {({ input: { onChange, value }, meta }: FieldRenderProps) => {
                    return (
                      <Dropdown fullWidth placeholder="Tag" options={dayOptions} onChange={onChange} value={value} />
                    );
                  }}
                </Field>
              </Column>
              <Column className={formColumn} mobile={columnMobileW1} desktop={columnDesktopW1}>
                <Field name={"birthMonth"}>
                  {({ input: { onChange, value }, meta }: FieldRenderProps) => {
                    return (
                      <Dropdown
                        fullWidth
                        placeholder="Monat"
                        options={monthOptions}
                        onChange={onChange}
                        value={value}
                      />
                    );
                  }}
                </Field>
              </Column>
              <Column className={formColumn} mobile={columnMobileW1} desktop={columnDesktopW1}>
                <Field name={"birthYear"}>
                  {({ input: { onChange, value }, meta }: FieldRenderProps) => {
                    return (
                      <Dropdown
                        fullWidth
                        placeholder="Jahr"
                        options={yearOptions}
                        onChange={onChange}
                        onClick={() => changeServiceFormInteraction(stepName, "BIRTH_DATE")}
                        value={value}
                      />
                    );
                  }}
                </Field>
              </Column>
            </ColumnContainer>
          );
        }}
      </Field>
      <Error name={"dateOfBirth"} className={errorMessage} />
    </>
  );
};

export default BirthDate;
